























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";

import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "DatePeriodSelect",
  components: {},
  props: {},
  data() {
    return {
      DateFormatter: DateFormatter,
      data: {
        beginDate: null,
        endDate: null,
      } as {
        beginDate: string | null;
        endDate: string | null;
      },
      hasChanges: false,
      toValidate: {} as any,
      //validation: null as ValidationResult<CategoryTypeJson> | null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {},

    //START date handling

    /* setDates() {
      var filterDate = "";

      let k = this.cachedDates;
      let i: keyof typeof k;

      for (i in this.cachedDates) {
        if (this.supportsDatePicker) {
          filterDate = this.cachedDates[i];
        } else {
          if (this.cachedDates[i].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedDates[i]);

            if (d != null) {
              filterDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.filterDates[i] = filterDate;
      }
    }, */

    //END date handling

    /* inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateCategoryTypeJson(this.details);
      }

      this.$forceUpdate();
    }, */

    /* removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    }, */
  },

  watch: {
    data: {
      deep: true,
      handler() {
        this.$emit("change", this.data);
      },
    },
  },

  computed: {},
});
